import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import companyThumbnail from '../../../../../img/company.png'
import { SolidButton, FadeButton } from '../../../../library/button'

import './style.scss'

const Index = () => {

	const details = useSelector(state => state.singleList.activeDisplay)
	const loading = useSelector(state => state.singleList.fetchSingleDetails.loading)

	const renderCallButton = phone => {
		if(loading){
			return <SolidButton spacing="right" disabled title="Laster" icon={<i className="fas fa-circle-notch fa-spin"></i>} color="blue"/>
		} else {
			if(phone){
				return(
					<a href={`tel:${phone ? phone:""}`}>
						<SolidButton spacing="right" title="Ring" icon={<i class="fad fa-phone"></i>} color="blue"/>
					</a>
				)
			} else {
				return <SolidButton disabled spacing="right" title="Utilgjengelig" icon={<i class="fad fa-phone"></i>} color="blue"/>
			}
		}
	}

	const renderEmailButton = email => {
		if(loading){
			return <FadeButton disabled title="Laster" icon={<i className="fas fa-circle-notch fa-spin"></i>} color="blue"/>
		} else {
			if(email){
				return(
					<a href={`mailto:${email ? email:""}`}>
						<FadeButton title="E-post" icon={<i class="fad fa-envelope"></i>} color="blue"/>
					</a>
				)
			} else {
				return(
					<FadeButton disabled title="Utilgjengelig" icon={<i class="fad fa-envelope"></i>} color="blue"/>
				)
			}
		}
	}

	return(
		<Row className="company-list-information-row">
			<Col className="thumbnail-col">
				<img alt="Kundebilde" className="company-thumbnail" src={companyThumbnail}/>
			</Col>
			<Col className="information-col">
				<h3 className="company-title">{loading && <i className="fas fa-circle-notch fa-spin"></i>} {loading && "Laster inn"} {!loading && details.general.name} {!details.general.name && !loading && "Utilgjengelig"}</h3>
				<p className="company-description">{loading && "Laster inn"} {!loading && details.general.industry} {!loading && !details.general.industry && "Utilgjengelig"}</p>
				<div className="company-buttons-container">
					{renderCallButton(details.contact.phone)}
					{renderEmailButton(details.contact.email)}
				</div>
			</Col>
		</Row>
	)
}

export default Index
